/**
 * Gets a value from secure storage
 * @param key The key to retrieve
 * @returns Promise<string | null> The stored value or null if not found
 */
export const getSecureItem = async (key: string): Promise<string | null> => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error("Error getting secure item:", error);
    return null;
  }
};

/**
 * Sets a value in secure storage
 * @param key The key to store
 * @param value The value to store
 * @returns Promise<void>
 */
export const setSecureItem = async (key: string, value: string): Promise<void> => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error("Error setting secure item:", error);
    throw error;
  }
};
